const StatusMessage = ({
  className,
  children,
  label,
  outlined,
}: $TSMigrationFixMe) => {
  return (
    <div className='wrap-status-message'>
      <div
        className={`${className}  g-status-message text-center
      ${!outlined ? "no-outlined" : ""}`}
      >
        {children || label}
      </div>
    </div>
  )
}

export default StatusMessage
